/**
 * Grid Role enum
 *
 * @package ext-components-base
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export enum GRID_ROLE {
	NONE = "none",
	FORM = "form"
}

export type GRID_ROLE_string = keyof typeof GRID_ROLE;

export const GRID_ROLE_default: GRID_ROLE_string = "NONE";
